import React from 'react';
import styles from './index.module.scss';

const QrLimitComponent = ({ onMainPageClick }) => {
  return (
    <div className={styles.overlay}>
      <div className={styles.backdrop} />
      <div className={styles.sheet}>
        <div className={styles.textBlock}>
          <p className={styles.title}>Ми зафіксували підвищену активність.</p>
          <p className={styles.description}>
            Ви перевищили доступний ліміт генерації кодів. Спробуйте пізніше.
          </p>
        </div>
        <button className={styles.mainButton} onClick={onMainPageClick}>
          На головну
        </button>
      </div>
    </div>
  );
};

export default QrLimitComponent;
